import { render, staticRenderFns } from "./CytologyResultsBuilder.vue?vue&type=template&id=f1629f9a&scoped=true&"
import script from "./CytologyResultsBuilder.vue?vue&type=script&lang=js&"
export * from "./CytologyResultsBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResultsBuilder.vue?vue&type=style&index=0&id=f1629f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1629f9a",
  null
  
)

export default component.exports